import { useState, useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { getStorageObject, formatStorageKey } from '../localStorageUtil';

export const useCalculatorLocalStorage = ({ itemId, isLocalStorageEnabled }) => {
  const { data, loading } = useDataModel('clientOnlyProduct', {
    skip: !isLocalStorageEnabled || !itemId,
    ssr: false,
    variables: {
      itemId
    }
  });
  const [calcLocalStorage, setCalcLocalStorage] = useState({
    storageKey: null,
    storageObj: null
  });

  useEffect(() => {
    if (!loading && data) {
      const storageKey = formatStorageKey(data?.product?.info);
      let storageObj = null;
      if (storageKey) {
        storageObj = getStorageObject(storageKey);
      }
      setCalcLocalStorage({
        storageKey,
        storageObj
      });
    }
  }, [loading, data]);

  return calcLocalStorage;
};